export default {
  columnDrilldownProperties: (state) => {
    return state.columnDrilldownProperties;
  },
};
